import { render } from "./PermissionsModal.vue?vue&type=template&id=41aee6d8"
import script from "./PermissionsModal.vue?vue&type=script&lang=js"
export * from "./PermissionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__